import * as React from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { Widget } from "../widget-types/Widget";
import { radioItems } from "app/components/React/PopularPagesFilters/popularPagesFilters.config";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import { SearchInput } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";

export class PopularPagesTableWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};
    constructor(props) {
        super(props);
        this.state = {
            isUtm: this.props.widgetFilters.isUtm ? this.props.widgetFilters.isUtm.toString() : "false", //as string because dropdown selectedId should be string.
        };
        this.selectedFilters = {
            isUtm: this.state.isUtm === "true",
            filter: this.props.widgetFilters.filter,
            isAll: this.props.widgetFilters.isAll,
            isNew: this.props.widgetFilters.isNew,
            isTrending: this.props.widgetFilters.isTrending,
            isEvergreen: this.props.widgetFilters.isEvergreen,
            sort: this.props.widgetFilters.orderBy,
            asc: false,
            includeSubDomains: false,
        };
        this.selectedFilters[this.getSelectedFilter()] = true;
        this.props.changeFilter(this.getSelectedFilters());
    }
    private getSearchValue() {
        const filterObject: any = Widget.filterParse(this.props.widgetFilters.filter);
        const filterObjectItem = filterObject[Object.keys(filterObject)[0]];
        return filterObjectItem && filterObjectItem.hasOwnProperty("value")
            ? filterObjectItem.value.replace(/"/g, "")
            : "";
    }
    private getSelectedFilters() {
        const filters = [];
        for (const filter in this.selectedFilters) {
            filters.push({ name: filter, value: this.selectedFilters[filter] });
        }
        return filters;
    }
    private onSearch = (value: string) => {
        const filterValue = Widget.filterStringify({
            Page: { operator: "contains", value: `"${value}"` },
        });
        this.selectedFilters.filter = filterValue;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private getSelectedFilter() {
        let selectedFilter = radioItems[0].value;
        radioItems.forEach((radioItem) => {
            if (this.props.widgetFilters[radioItem.value] === true) {
                selectedFilter = radioItem.value;
                return;
            }
        });
        return selectedFilter;
    }

    private onSelectUtm = (item) => {
        this.setState({ isUtm: item.id });
        this.selectedFilters.isUtm = item.id === "true";
        this.props.changeFilter(this.getSelectedFilters());
    };
    private onSelectSwitcher = (item) => {
        radioItems.forEach((radioItem) => {
            if (item.id === radioItem.value) {
                this.selectedFilters[radioItem.value] = true;
            } else {
                this.selectedFilters[radioItem.value] = false;
            }
        });
        if (item.id === "isTrending") {
            this.onSelectOrderBy({ id: "ChangeInShare desc", text: "Change" });
        }
        this.props.changeFilter(this.getSelectedFilters());
    };

    private onSelectOrderBy = (item) => {
        this.selectedFilters.sort = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };

    render() {
        return (
            <div
                key="dynamicFiltersContainer"
                className="filters"
            >
                <div
                    key="searchterm"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.searchterm`}</I18n>
                    </h5>
                    <SearchInput
                        defaultValue={this.getSearchValue()}
                        onChange={this.onSearch}
                        debounce={400}
                    />
                </div>
                <div
                    key="utm"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.utm`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="utmFilter"
                        items={[
                            { id: "true", text: "Yes" },
                            { id: "false", text: "No" },
                        ]}
                        selectedId={this.state.isUtm}
                        onSelect={this.onSelectUtm}
                    />
                </div>
                <div
                    key="switcher"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.switcher`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="switcherFilter"
                        items={radioItems.map((radioItem) => ({
                            id: radioItem.value,
                            text: i18nFilter()(radioItem.label),
                        }))}
                        selectedId={this.getSelectedFilter()}
                        onSelect={this.onSelectSwitcher}
                    />
                </div>
                <div
                    key="orderby"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.orderBy`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="orderbyFilter"
                        items={[
                            { id: "Share", text: "Traffic Share" },
                            { id: "Change", text: "Change" },
                        ]}
                        selectedId={this.selectedFilters.sort}
                        onSelect={this.onSelectOrderBy}
                    />
                </div>
                <div
                    key="includeSubDomains"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.includeSubDomains`}</I18n>
                    </h5>
                    <StatefulDropdown
                        // this filter was not remove in past by mistake, as part of PII effort(Jira sim-26282) we blocked the option to requests includeSubDomains
                        // in popularPages and Folders (all requests should have includeSubDomains set to false).
                        // It has been disabled but not removed in order not to confuse users who are used to seeing the filter.
                        disabled={true}
                        key="includeSubDomainsFilter"
                        items={[{ id: "false", text: "No" }]}
                        selectedId={"false"}
                    />
                </div>
            </div>
        );
    }
}
